import styled from 'styled-components';

export const CartTabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: #fff;
  min-width: 500px;
  max-width: fit-content;
`;

export const TabsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  background-color: #f3f4f8;
  column-gap: 20px;
`;

type TabsProps = {
  active: boolean;
};

export const Tab = styled.div<TabsProps>`
  display: flex;
  color: ${props => (props.active ? '#222247' : '#fff')};
  flex-grow: 1;
  column-gap: 10px;
  height: 50px;
  cursor: pointer;
  background: ${props => (props.active ? '#fff 0% 0% no-repeat padding-box' : ' #c9cbd3 0% 0% no-repeat padding-box')};
  border-radius: 4px 4px 0px 0px;
  justify-content: center;
  align-items: center;
  svg {
    fill: ${props => (props.active ? '#222247' : '#fff')};
  }
`;

export const TabTitle = styled.p`
  font-weight: 600;
  font-size: 18px;
  letter-spacing: -0.2px;
  opacity: 1;
`;
